import React from 'react'
import './Marketingconsultancy.css'
import Navbar from "./Navbar";
import Footer from "./Footer";
import { FaCheck } from "react-icons/fa";
import './Marketingconsultancy.css';


function Marketingconsultancy() {
  return (
    <div id="marketingconsultancy" className='marketing-consultancy'>
      <div className='aboutcontent'>
        <div className="marketingconsultancy-text-center">
        <h1>Marketing Consultancy</h1>
        <div className="marketingconsultancy-underline"></div>
        <p>We help businesses understand their market, strengthen their
          brand, and <br /> build long-term growth strategies.
        </p>
        <ul class="marketingconsultancy-list">
          <li><FaCheck className="tick-icon" />Custom Website Design</li>
          <li><FaCheck className="tick-icon" />Responsive Development</li>
          <li><FaCheck className="tick-icon" />E-commerce Websites</li>
          <li><FaCheck className="tick-icon" />Landing Pages</li>
          <li><FaCheck className="tick-icon" />Website Revamp & Maintenance</li>
        </ul>
      </div>
      <div className="marketing-consultancy-image-section">
        <img src='Marketing_consultancy/man.png' className="marketingconsultancy-image" />
      </div>
      </div>
    </div>
  )
}

export default Marketingconsultancy
